import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'src/app/shared';
import {GuideComponent} from "./guide.component";
import {GuideRoutingModule} from "./guide-routing.module";
import {NzButtonModule, NzIconModule, NzInputModule} from "ng-zorro-antd";
import { HighlightDirective } from './directive/highlight.directive';
import { SearchPipe } from './pipe/search.pipe';

@NgModule({
    declarations: [
        GuideComponent,
        HighlightDirective,
        SearchPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        GuideRoutingModule,
        SharedModule,
        NzInputModule,
        NzButtonModule,
        NzIconModule,

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        HighlightDirective
    ]
})
export class GuideModule { }
